import AxiosInstance from './config/Http'
import Config from './config/Constants'

export default {
    post: (id: string, file: File, classification: string) => {
        const formData = new FormData();
        formData.append("file", file);
        formData.append("classification", classification);
        return AxiosInstance.post<any>(`${Config.core.items}/attach/${id}`, formData, { headers: { "Content-Type": "multipart/form-data" } })
    },
    delete: (id: string) => AxiosInstance.delete<any>(`${Config.core.items}/${id}`),

    getItemByTicketId:(id: string) =>  AxiosInstance.get<any>(`${Config.core.items}/?ticketId.equals=${id}`)
}
